import { render, staticRenderFns } from "./PlanCards.vue?vue&type=template&id=62aa7bae&scoped=true&"
import script from "./PlanCards.vue?vue&type=script&lang=js&"
export * from "./PlanCards.vue?vue&type=script&lang=js&"
import style0 from "./PlanCards.vue?vue&type=style&index=0&id=62aa7bae&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62aa7bae",
  null
  
)

export default component.exports